import React, { useEffect } from "react";

export default function GuideModal({ guide, onClose }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  if (!guide) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/85 p-4"
      onClick={onClose}
    >
      <div
        className="panel relative max-h-[85vh] w-full max-w-lg overflow-y-auto p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close guide"
          className="absolute right-4 top-4 border-2 border-mist/40 px-2 py-1 font-display text-[10px] text-mist/70 transition-colors hover:border-danger hover:text-danger"
        >
          ✕
        </button>

        <p className="label-pixel mb-1 pr-10 text-cyan">{guide.tagline}</p>
        <h2 className="pixel-heading mb-5 pr-10 text-base text-mist sm:text-lg">{guide.title}</h2>

        <div className="space-y-5">
          {guide.sections.map((section, i) => (
            <div key={i}>
              <p className="mb-1.5 font-display text-[9px] uppercase tracking-wide text-gold">
                {section.heading}
              </p>
              {section.body && (
                <p className="text-xs leading-relaxed text-mist/80">{section.body}</p>
              )}
              {section.list && (
                <ul className={`space-y-1.5 text-xs leading-relaxed text-mist/80 ${section.body ? "mt-2" : ""}`}>
                  {section.list.map((item, j) => (
                    <li key={j} className="flex gap-2">
                      <span className="text-cyan">▸</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <button onClick={onClose} className="btn-cyan mt-6 w-full">
          CLOSE
        </button>
      </div>
    </div>
  );
}
